export default "__VITE_ASSET__C1iwOJ4I__"